module.exports = __webpack_public_path__ + "static/crWA-b9fcd6511b163b8d34b16d45004f1f22.png";